import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { WorkflowDesignerModule } from './designer';
import { WorkflowGraphModule } from './graph';
import { WorkflowVertexLibraryModule } from './vertex-library';

const MODULES = [
  WorkflowDesignerModule,
  WorkflowGraphModule,
  WorkflowVertexLibraryModule
];

@NgModule({
  imports: [
    CommonModule,
    ...MODULES
  ],
  exports: [
    ...MODULES
  ]
})
export class WorkflowUILibraryModule {

}



// WEBPACK FOOTER //
// ./src/library/workflow-ui-library.module.ts